// A creator's page writes where the visitor is into its address (28 Oct
// 2026): /<handle>/<place>/<type+type>/<tab>, each part only when picked —
// the tab last (Stéphane).
// The parts live on the section's element (data-url-tab, -where, -types),
// set by the tabs and the filters, and written together so neither drops the
// other's. A page without data-page-base (a preview) writes nothing.
export function writePagePath(element) {
  const base = element.dataset.pageBase
  if (!base) return false
  const parts = [ element.dataset.urlWhere, element.dataset.urlTypes, element.dataset.urlTab ].filter(Boolean)
  history.replaceState(null, "", [ base, ...parts ].join("/"))
  return true
}
